import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC } from 'react';
import { ApprovingInvoiceReports as ApprovingInvoiceReportsList } from './components/List';

export const ApprovingInvoiceReports: FC = () => {
  const ffContext = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={ffContext}
        domain='ap-payment-request-support-agent'
      >
        <OpenFeatureProvider
          pollInterval={-1}
          context={ffContext}
          domain='ap-data-extraction-mismatch-alert'
        >
          <OpenFeatureProvider
            pollInterval={-1}
            context={ffContext}
            domain='ap-data-extraction-mismatch-alert-phase-2'
          >
            <OpenFeatureProvider
              pollInterval={-1}
              context={ffContext}
              domain='ap-approval-drawer-view-optimization'
            >
              <ApprovingInvoiceReportsList />
            </OpenFeatureProvider>
          </OpenFeatureProvider>
        </OpenFeatureProvider>
      </OpenFeatureProvider>
    </Wrapper>
  );
};
